export type DatevSource = "direct-payment" | "payment";
export type DatevKind = "revenues" | "payments" | "receipts";
export type DatevStatus = "READY" | "GENERATING" | "FAILED";

export interface DatevExportRow {
  year: number;
  month: number;
  source: DatevSource;
  kind: DatevKind;
  exportId: string;
  status: DatevStatus;
  fileName: string | null;
  sizeBytes: number | null;
  generatedAt: string | null;
  totalCount: number | null;
  remainingCount: number | null;
  missingCount: number | null;
}

export const slotKey = (month: number, source: DatevSource, kind: DatevKind): string =>
  `${month}-${source}-${kind}`;

export const MONTH_NAMES = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

export interface DatevAccountOverrides {
  debtorAccount: string;
  revenueAccount: string;
  bankAccount: string;
  stripeFeesAccount: string;
}
